module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('nd-multi-select-listbox', {
    attrs: {
      "brandId": _vm.brandId,
      "getDataH": _vm.getDataH,
      "storeId": _vm.storeId,
      "type": 1
    },
    on: {
      "update:choose": _vm.updateChoose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear-both"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-1 font-size-subtitle-2 text-right"
  }, [_vm._v("已選" + _vm._s(_vm.chose.length) + "擇")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3 font-size-subtitle-2 font-weight-regular"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v("已選取全部配料庫，請選擇要套用至哪些門市，按下確認後即複製")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52c5c505"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/nd-copy-options-store.vue
// module id = 2419
// module chunks = 1